import { answeredQues } from "./testHelper";

export default function nextQues(
  dispatchAnswer,
  dispatchHelper,
  nextQuesId,
  answer,
  timeSpend,
  question,
  testFormat
) {
  console.log(nextQuesId, answer, timeSpend, question, testFormat);
  dispatchAnswer({
    type: "ADD_ANSWER",
    payload: answeredQues(testFormat, answer, question, timeSpend),
  });
  dispatchHelper({
    type: "RUNNING_QUES_ID",
    payload: nextQuesId,
  });
  dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
  dispatchHelper({ type: "USER_INPUT", payload: false });
}

export function createShuffledArray(length) {
  const numbers = Array.from({ length: 10 }, (_, index) => index);

  let currentIndex = numbers.length;

  while (currentIndex != 0) {
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [numbers[currentIndex], numbers[randomIndex]] = [
      numbers[randomIndex],
      numbers[currentIndex],
    ];
  }

  if (numbers[0] === 0) {
    numbers.splice(0, 1);
    numbers.push(0);
  }
  return numbers.slice(0, length);
}
